import type { RefObject } from 'react';
import { useEffect, useState } from 'react';

export const useIntersection = (ref: RefObject<HTMLElement>, threshold = 0.25) => {
  const [isIntersecting, setIsIntersecting] = useState<boolean>(false);

  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      },
      { threshold: threshold },
    );
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, threshold]);

  return isIntersecting;
};
